<template>
  <v-app>
    <v-app-bar app flat color="primary" dark clipped-left height="90">
      <div class="d-flex align-center">
        <SvgIcon icon="cp-logo-1" height="60px" fill="white"></SvgIcon>
      </div>
      <v-spacer></v-spacer>
    </v-app-bar>

    <v-img
      :src="sargo"
      height="300"
      width="500"
      contain
      style="position: absolute; top: 0px; right: -180px; filter: opacity(20%)"
    ></v-img>

    <v-img
      :src="cabrilla"
      height="200"
      width="400"
      contain
      style="
        position: absolute;
        bottom: 480px;
        left: 30px;
        filter: opacity(20%);
        transform: scaleX(-1);
      "
    ></v-img>

    <v-content class="grey lighten-5">
      <p
        class="display-1 font-weight-bold primary--text text-center pt-12 pb-12"
      >
        Autenticación
      </p>
      <v-row class="pa-2 pb-10">
        <v-col cols="12" md="10" sm="10" class="mx-auto">
          <v-row>
            <v-col cols="12" md="6">
              <v-card class="flex rounded-custom">
                <v-card-title class="primary white--text justify-center">
                  <span>Tengo una cuenta</span>
                </v-card-title>
                <v-form ref="loginForm" v-model="loginFormValid">
                  <div class="pa-4 pt-8 flex card-custom-background">
                    <div class="mt-8">
                      <v-text-field
                        v-model="practitioner.email"
                        label="Email"
                        :rules="[
                          () => !!practitioner.email || 'Campo requerido'
                        ]"
                        rounded
                        outlined
                      ></v-text-field>
                      <v-text-field
                        type="password"
                        v-model="practitioner.password"
                        label="Contraseña"
                        :rules="[
                          () => !!practitioner.password || 'Campo requerido'
                        ]"
                        rounded
                        outlined
                      ></v-text-field>
                    </div>
                    <v-btn
                      text
                      block
                      small
                      class="mb-4"
                      color="primary"
                      @click="dialogRecoveryPassword = true"
                      >¿Olvidaste tu contraseña?</v-btn
                    >
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        v-on:click="login"
                        color="#009c5e"
                        dark
                        width="200"
                        large
                        rounded
                        >Ingresar</v-btn
                      >
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </div>
                </v-form>
              </v-card>
            </v-col>
            <v-col cols="12" md="6">
              <v-card class="flex rounded-custom">
                <v-card-title class="primary white--text justify-center">
                  <span>Crea tu cuenta</span>
                </v-card-title>
                <div class="pa-4 pt-8 card-custom-background">
                  <PractitionerRegisterForm
                    v-bind:practitioner.sync="practitionerRegister"
                  ></PractitionerRegisterForm>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      v-on:click="register"
                      width="200"
                      color="#009c5e"
                      dark
                      rounded
                      large
                      class="radius mt-2"
                      >Registrarme</v-btn
                    >
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-content>

    <v-dialog v-model="dialogRegisterFail" max-width="600">
      <v-card>
        <div class="d-flex flex-column align-items-center pa-4">
          <sweetalert-icon icon="error" />
          <p class="font-weight-medium text-center title">
            Ha ocurrido un error en el registro
          </p>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogRegisterFail = false" color="primary"
            >Aceptar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogLoginFail" max-width="600">
      <v-card>
        <div class="d-flex flex-column align-items-center pa-4">
          <sweetalert-icon icon="error" />
          <p class="font-weight-medium text-center title">Datos incorrectos</p>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogLoginFail = false" color="primary"
            >Aceptar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogLoginNotAuth" max-width="600">
      <v-card>
        <div class="d-flex flex-column align-items-center pa-4">
          <sweetalert-icon icon="info" />
          <p class="font-weight-medium text-center title">
            Tu cuenta aún no está validada, vuelve a intentarlo más tarde!
          </p>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogLoginNotAuth = false" color="primary"
            >Aceptar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogRecoveryPassword" max-width="500">
      <v-card>
        <v-card-title>
          <span class="primary--text">Recuperar contraseña</span>
          <v-spacer></v-spacer>
          <v-btn @click="dialogRecoveryPassword = false" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-4">
          <v-stepper v-model="recoveryStepperActiveTab">
            <v-stepper-header class="font-weight-light body-2">
              <v-stepper-step
                :complete="recoveryStepperActiveTab > 1"
                step="1"
                editable
                >Solicitar</v-stepper-step
              >
              <v-divider></v-divider>
              <v-stepper-step step="2">Completar</v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1" class="pa-2 pa-md-6">
                <v-form
                  v-model="recoveryForm1Valid"
                  ref="recoveryForm1"
                  :lazy-validation="true"
                >
                  <p class="body-1 font-weight-medium pt-2 pb-2">
                    Ingresa tu correo para comenzar la recuperación de
                    contraseña
                  </p>
                  <v-text-field
                    label="Correo"
                    outlined
                    v-model="recoveryPasswordForm.email"
                    :rules="[
                      () => !!recoveryPasswordForm.email || 'Campo requerido'
                    ]"
                    rounded
                  ></v-text-field>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      @click="startRecoveryPassword"
                      color="primary"
                      :loading="recoveryStatus === 'loading'"
                      :disabled="!recoveryForm1Valid"
                      >Solicitar código de recuperación</v-btn
                    >
                  </v-card-actions>
                </v-form>
              </v-stepper-content>
              <v-stepper-content step="2" class="pa-2 pa-md-6">
                <v-form
                  v-model="recoveryForm2Valid"
                  ref="recoveryForm2"
                  :lazy-validation="true"
                >
                  <p class="body-1 font-weight-medium pt-2 pb-2">
                    Ingresa el código de recuperación enviado a tu correo y la
                    nueva contraseña
                  </p>

                  <p
                    v-if="recoveryStatus === 'error'"
                    class="body-1 font-weight-medium pt-2 pb-2"
                  >
                    Ha ocurrido un error recuperando la contraseña
                  </p>

                  <v-text-field
                    label="Código de recuperación"
                    outlined
                    v-model="recoveryPasswordForm.token"
                    :rules="[
                      () => !!recoveryPasswordForm.token || 'Campo requerido'
                    ]"
                    rounded
                  ></v-text-field>

                  <v-text-field
                    label="Nueva contraseña"
                    outlined
                    v-model="recoveryPasswordForm.password"
                    :type="showRecoveryPassword ? 'text' : 'password'"
                    @click:append="showRecoveryPassword = !showRecoveryPassword"
                    :append-icon="
                      showRecoveryPassword ? 'mdi-eye' : 'mdi-eye-off'
                    "
                    :rules="[
                      () => !!recoveryPasswordForm.password || 'Campo requerido'
                    ]"
                    rounded
                  ></v-text-field>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      @click="completeRecoveryPassword"
                      color="primary"
                      :loading="recoveryStatus === 'loading'"
                      :disabled="!recoveryForm2Valid"
                      >Recuperar mi contraseña</v-btn
                    >
                  </v-card-actions>
                </v-form>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-img :src="castanetas" height="200" full-width></v-img>

    <v-footer class="primary darken-2 d-flex justify-center" height="120">
      <div>
        <SvgIcon icon="cp-logo-2" height="50px" fill="white"></SvgIcon>
      </div>
    </v-footer>
  </v-app>
</template>

<script>
import PractitionerRegisterForm from "./Practitioner/PractitionerRegisterForm";
import SvgIcon from "@/components/SvgIcon";

export default {
  components: { PractitionerRegisterForm, SvgIcon },
  data: () => ({
    sargo: require("@/assets/landing/31_Sargo (A.scapularis).png"),
    cabrilla: require("@/assets/landing/16_Cabrilla española (P.humeralis).png"),
    castanetas: require("@/assets/landing/castanetas.jpg"),
    practitioner: {},
    practitionerRegister: {},
    loginFormValid: true,
    recoveryPasswordForm: {},
    dialogWelcome: false,
    dialogRegisterFail: false,
    dialogLoginFail: false,
    dialogLoginNotAuth: false,
    recoveryStepperActiveTab: 1,
    recoveryStatus: "none",
    showRecoveryPassword: false,
    recoveryForm1Valid: true,
    recoveryForm2Valid: true,
    dialogRecoveryPassword: false
  }),
  computed: {
    isLoggedIn: function() {
      return this.$store.getters["authPractitioner/isLoggedIn"];
    }
  },
  methods: {
    login: async function() {
      try {
        this.$refs.loginForm.validate();
        if (!this.loginFormValid) {
          return;
        }

        let results = await this.$store.dispatch(
          "authPractitioner/login",
          this.practitioner
        );
        if (this.$store.getters.getFromUrl) {
          this.$router.push(this.$store.getters.getFromUrl);
          this.$store.dispatch("authPractitioner/saveFromUrl", "");
        } else {
          if (results.validated) {
            this.$router.push("/costa-pez/home");
          } else {
            this.dialogLoginNotAuth = true;
          }
        }
        this.$emit("login");
      } catch (err) {
        this.dialogLoginFail = true;
        //console.log(err);
      }
    },
    register: async function() {
      try {
        await this.$store.dispatch(
          "authPractitioner/register",
          this.practitionerRegister
        );
        if (this.$store.getters.getFromUrl) {
          this.$router.push(this.$store.getters.getFromUrl);
          this.$store.dispatch("authPractitioner/saveFromUrl", "");
        } else {
          this.$router.push("/costa-pez/usuario/mi-cuenta");
          // this.$router.push("/costa-pez/home");
        }
      } catch (err) {
        this.dialogRegisterFail = true;
      }
    },
    async startRecoveryPassword() {
      try {
        if (!this.$refs.recoveryForm1.validate()) {
          return;
        }
        this.recoveryStatus = "loading";
        await this.$http.post("practitioner/restore-account", {
          email: this.recoveryPasswordForm.email.toLowerCase()
        });

        this.recoveryStatus = "none";
        this.recoveryStepperActiveTab = 2;
      } catch (err) {
        this.recoveryStatus = "error";
      }
    },
    async completeRecoveryPassword() {
      try {
        if (!this.$refs.recoveryForm2.validate()) {
          return;
        }
        this.recoveryStatus = "loading";
        let { email, token, password } = this.recoveryPasswordForm;
        email = email.toLowerCase();
        await this.$http.post("practitioner/complete-restore-account", {
          token,
          email,
          password
        });

        this.dialogRecoveryPassword = false;

        this.practitioner = { email, password };
        this.login();
      } catch (error) {
        this.recoveryStatus = "error";
      }
    }
  },
  mounted() {
    if (this.isLoggedIn) {
      this.$router.push("/costa-pez/usuario/mi-cuenta");
    }
  },
  watch: {
    dialogRecoveryPassword() {
      if (!this.dialogRecoveryPassword) {
        this.$refs.recoveryForm1.reset();
        this.recoveryPasswordForm = {};
      }
    }
  }
};
</script>

<style>
.card-custom-background {
  background: #c0e2e6;
}
</style>
